/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import OptionsProduct from "../OptionsModels/OptionsProduct";

export interface Address {
  street?: string;
  city?: string;
  zipcode?: string;
  state?: string | number;
  country?: number | string;
}

export default interface Tenant {
  tenantId: string;
  tenantName: string;
  // forgeCustomerId: string;
  timezone: string;
  datacenter: string;
  currency: string;
  lastUpdatedTimeStamp: string;
  headquarterAddress?: string;
  products?: OptionsProduct[];
  utilityType?: string;
  organizationName?: string;
  organizationId?: string;
  groupId?: string;
  address?: Address;
  region: number | string;
  latitude?: string | number;
  longitude?: string | number;
  createdon: string;
  version: number;
  statusCode: number;
  status?: StatusCode;
}
export enum StatusCode {
  noTenant = "noTenant",
  InIt = "InIt",
  InProgress = "InProgress",
  SetupCompleted = "SetupCompleted",
  TenantUpdated = "UpdateInprogress",
  Invalid = "Invalid",
}

interface StatusDetails {
  statusName: string;
  statusColor: string;
}

const statusMapping: Record<StatusCode, StatusDetails> = {
  [StatusCode.noTenant]: { statusName: "No tenant", statusColor: "red" },
  [StatusCode.InIt]: { statusName: "Initialization", statusColor: "red" },
  [StatusCode.InProgress]: { statusName: "In Progress", statusColor: "orange" },
  [StatusCode.SetupCompleted]: {
    statusName: "Active",
    statusColor: "green",
  },
  [StatusCode.TenantUpdated]: {
    statusName: "In Progress",
    statusColor: "red",
  },
  [StatusCode.Invalid]: { statusName: "Invalid", statusColor: "red" },
};

export const getStatusDetails = (statusCode: StatusCode): StatusDetails => {
  return statusMapping[statusCode];
};
